import React from 'react';
import styles from './index.module.scss';

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <g>
      <rect x="5.83" y="10.83" width="1.66" height="1.66" />
      <rect x="7.5" y="9.17" width="1.66" height="1.66" />
      <rect x="7.5" y="12.5" width="1.66" height="1.66" />
      <rect x="9.17" y="7.5" width="1.66" height="1.66" />
      <rect x="9.17" y="14.17" width="1.66" height="1.66" />
      <rect x="10.83" y="5.83" width="1.66" height="1.66" />
      <rect x="10.83" y="15.83" width="1.66" height="1.66" />
      <rect x="12.5" y="10.83" width="1.66" height="1.66" />
    </g>
  </svg>
);

const ArrowPagination = ({ currentIndex, total, onPrevious, onNext, className }) => {
  if (total <= 1) return null;

  return (
    <div className={`${styles.container} ${className || ''}`}>
      <button
        className={`${styles.arrow} ${styles['arrow--left']}`}
        onClick={onPrevious}
        aria-label="Previous"
        disabled={currentIndex === 0}
      >
        <ArrowIcon />
      </button>
      <span className={styles.counter}>
        {currentIndex + 1} / {total}
      </span>
      <button
        className={`${styles.arrow} ${styles['arrow--right']}`}
        onClick={onNext}
        aria-label="Next"
        disabled={currentIndex === total - 1}
      >
        <ArrowIcon />
      </button>
    </div>
  );
};

export default ArrowPagination;
